import { PatientCarePlanControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type Param = { carePlanId: string; status: boolean; xTENANTID?: string };

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveCareplan = () =>
  useMutationWithLoading(async (param: Param) =>
    new PatientCarePlanControllerApi(
      getConfigObject()
    ).updateCarePlanArchiveStatus(
      param.carePlanId,
      param.status,
      param.xTENANTID //xTENANTID
    )
  );
